import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class ALERTComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  constructor(public commonService: CommonService) { }

  ngOnInit() {
    this.item.data = this.commonService.setDefaultSetting(this.item.data);
  }

}
